import React, {useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {fetchCurrentUserFromApi} from "../actions/currentUser";
import "./App.css";
import {Translate} from "./Language/Translate";
import Spinner from "./Spinner";
import SubApp from "./SubApp";
import {fetchCompaniesFromAPI} from "../actions/companies";
import {fetchTextbausteineFromAPI} from "../actions/textbausteine";
import AdminArea from "./Admin/AdminArea";

function App() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(
    function () {
      const fetchUser = () => {
        const userLS = JSON.parse(localStorage.getItem("user"));
        // console.log({userLS});
        if (userLS?.username) {
          // console.log("##############################################", userLS);
          dispatch(fetchCurrentUserFromApi(userLS.username));
          dispatch(fetchCompaniesFromAPI());
          dispatch(fetchTextbausteineFromAPI());
        }
        (() => setIsLoading(false))();
      };
      if (isLoading) fetchUser();
    },
    [isLoading, dispatch, setIsLoading]
  );

  if (isLoading) return <Spinner />;

  Translate.language = "deDE";

  return (
    <div id="idApp">
      <SubApp />
      {/* <AdminArea/> */}
      {/* <AppTest/> */}
    </div>
  );
}

export default App;
